/* eslint-disable max-lines-per-function */
import React from 'react';
import { GridLegacy as Grid } from '@mui/material';
import { t } from 'i18next';
import { CardWrapper } from '@monorepo/react/material-login-page';
import { Alert } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import {
  useGetEmailLogsQuery,
  useUpdateEmailLogMutation,
} from './confirm.generated';
import { LinkButton } from '@monorepo/react/material-buttons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';

export const ConfirmPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const ids = id ? id.split('.') : [];
  const confirmId = ids[0];
  const incidentId = ids[1];

  const { data } = useGetEmailLogsQuery({
    variables: {
      filter: { confirmId: { eq: confirmId } },
    },
    skip: !confirmId,
  });

  const [updateEmailLog] = useUpdateEmailLogMutation();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!id) return;
    if (data && data.emailLogs.edges.length === 0)
      navigate('/', { replace: true });
  }, [id, data, navigate]);

  React.useEffect(() => {
    if (!id) return;
    let recipientIdTemp = null;
    if (
      data &&
      data.emailLogs.edges.length > 0 &&
      !data.emailLogs.edges[0].node.confirmedAt
    ) {
      const emailLogId = data.emailLogs.edges[0].node.id;
      recipientIdTemp = data.emailLogs.edges[0].node.recipientId;

      const updateLog = async () => {
        await updateEmailLog({
          variables: {
            id: emailLogId,
            newState: {
              confirmedAt: new Date(),
            },
          },
        });
      };

      updateLog();
    }
  }, [id, data, updateEmailLog]);

  if (!id) return null;

  let recipientId = null;

  if (
    data &&
    data.emailLogs.edges.length > 0 &&
    data.emailLogs.edges[0].node.recipientId
  ) {
    recipientId = data.emailLogs.edges[0].node.recipientId;
  }

  return (
    <CardWrapper title={`confirm`}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Alert severity="success">
            {String(t('incidents.report.notification.confirmManually'))}
          </Alert>
        </Grid>
        <Grid
          item
          xs={12}
          container
          justifyContent="center"
          alignItems="center"
        >
          {data && recipientId && incidentId && (
            <LinkButton
              to={`/incidents/${incidentId}`}
              startIcon={<FontAwesomeIcon icon={faFileAlt} />}
            >
              {String(t(`incidents.report.link`))}
            </LinkButton>
          )}
        </Grid>
      </Grid>
    </CardWrapper>
  );
};
